export function getJwtPayload(token) {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;

  try {
    // JWT uses base64url encoding
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
    const json = decodeURIComponent(
      atob(padded)
        .split('')
        .map((c) => `%${c.charCodeAt(0).toString(16).padStart(2, '0')}`)
        .join('')
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function isTokenExpired(token, skewSeconds = 30) {
  const payload = getJwtPayload(token);
  const exp = payload?.exp;

  // If we can't read exp, treat as expired so we fail closed.
  if (typeof exp !== 'number') return true;

  const nowSeconds = Math.floor(Date.now() / 1000);
  return exp <= nowSeconds + Math.max(0, skewSeconds);
}

